import { useUser } from "contexts/UserContext";
import OAuthLoadingPage from "pages/OAuthLoading";
import PasswordResetDone from "pages/PasswordResetDone/PasswordResetDone";
import { routes } from "pages/routes";
import SelfSignUp from "pages/SelfSignUp/SelfSignUp";
import SelfForgotPassword from "pages/SignIn/ForgotPassword";
import PasswordReset from "pages/SignIn/PasswordReset";
import SignIn, { SignInLocationState } from "pages/SignIn/SignIn";
import SignInSSO from "pages/SignInSSO";
import SignUpByInvitation from "pages/SignUpByInvitation";
import VerifyPendingUser from "pages/VerifyPendingUser";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

export default function PublicRoutes() {
  const location = useLocation();
  const user = useUser(false);
  if (user) {
    return <Navigate to={routes.root.path()} replace />;
  }

  return (
    <Routes key={location.pathname} location={location}>
      <Route
        path={routes.public.selfSignupVerifyIndividual.pattern}
        element={<VerifyPendingUser />}
      />
      <Route path={routes.public.verify.pattern} element={<VerifyPendingUser />} />

      <Route path={routes.public.resetDone.pattern} element={<PasswordResetDone />} />
      <Route path={routes.public.changePassword.pattern} element={<PasswordReset />} />
      <Route path={routes.public.signInSso.pattern} element={<SignInSSO />} />
      <Route path={routes.public.signInOAuth.pattern} element={<OAuthLoadingPage />} />
      <Route path={routes.public.signIn.pattern} element={<SignIn />} />
      <Route path={routes.public.signUpSetupWithCode.pattern} element={<SelfSignUp />} />
      <Route path={routes.public.signUpWithCode.pattern} element={<SelfSignUp />} />
      <Route path={routes.public.selfSignUp.pattern} element={<SelfSignUp />} />

      <Route path={routes.public.inviteVerify.pattern} element={<SignUpByInvitation />} />

      <Route path={routes.public.forgot.pattern} element={<SelfForgotPassword />} />

      <Route path={routes.public.passwordVerify.pattern} element={<PasswordReset />} />

      <Route
        path="*"
        element={
          user ? (
            <Navigate to={routes.root.path()} replace />
          ) : (
            <Navigate
              to={routes.public.signIn.path()}
              state={{ returnPath: location.pathname } satisfies SignInLocationState}
              replace
            />
          )
        }
      />
    </Routes>
  );
}
